import { render, staticRenderFns } from "./MegaMenuTree.vue?vue&type=template&id=5ef80c80&scoped=true"
import script from "./MegaMenuTree.vue?vue&type=script&lang=js"
export * from "./MegaMenuTree.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuTree.vue?vue&type=style&index=0&id=5ef80c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef80c80",
  null
  
)

export default component.exports